import { Typography } from "@bonusx-global/bx-design-system";
import type { PropsWithChildren } from "react";
import type { AiResponseParagraphProps } from "./ai-response-markdown-paragraph.interfa";

function AiResponseParagraph({ children }: PropsWithChildren<AiResponseParagraphProps>): JSX.Element {
  return <Typography>{children}</Typography>;
}

export default AiResponseParagraph;
